export default __webpack_public_path__ + "static/media/H4005.2d34c88d.mp3";